import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/en';

dayjs.extend(utc);
dayjs.extend(timezone);
console.log(dayjs.tz.guess())

export const convertToLocal = timestamp => {
  let formattedDateTime = '';
  if (timestamp) {
    formattedDateTime = dayjs.unix(timestamp).tz(dayjs.tz.guess()).format('DD MMMM, YYYY - h:mm:ss A');
    return formattedDateTime;
  } else {
    return formattedDateTime;
  }
};
